module.exports = __webpack_public_path__ + "static/media/eng_d_2474.2f3237b7.vtt";